
// Import the component from where it's defined
import { MegaMenuItem as UIMegaMenuItem, MegaMenuItemProps } from "@/components/ui/mega-menu-item";

// Re-export the component and its props
export type { MegaMenuItemProps };
export const MegaMenuItem = UIMegaMenuItem;

// Default export for backward compatibility
export default UIMegaMenuItem;
